import {checkEmptyObj} from "helper/common";

const hanleArray = (data, name) => {
  const listKey = Object.keys(data || {});
  const listValidKey = listKey.filter(key => data[key]);
  let subName = `<span>${name}:</span>`;
  if (listValidKey && !Array.isArray(data)) {
    const res = listValidKey.map((e1, index) => {
      return `<span> ${
        data[e1] && `${e1} ${index != listValidKey.length - 1 ? "- " : ""}`
      }</span>`;
    });
    return `<div> ${subName + res.join("")}
   </div>`;
  } else {
    return `<div>${
      subName +
      data
        .map((e, index) => {
          return `
      <span> ${e} ${
            index < data.length - 1 && data.length > 1 ? "-" : ""
          }</span>`;
        })
        .join(" ")
    }</div>`;

    // return subName + res.join('');
  }
};

const handleInforItem = (label, value) => {
  return `
<p> ${label}: ${value}</p>
`;
};

const CheckDataKhamMat = (data, setDataEditorLeft, setDataEditorRight) => {
  const khamMat = JSON.parse(data);
  // Trái
  //
  //
  const leftAPPEARANC = khamMat?.leftJsonValue?.APPEARANCE;
  console.log("🚀 ~ CheckDataKhamMat ~ khamMat:", khamMat);
  const leftINJURY = khamMat?.leftJsonValue?.INJURY;
  const leftAPPENDAGES = khamMat?.leftJsonValue?.APPENDAGES;
  const leftCONJUNCTIVA = khamMat?.leftJsonValue?.CONJUNCTIVA;

  const leftSCLERA = khamMat?.leftJsonValue?.SCLERA;
  const leftCORNEA = khamMat?.leftJsonValue?.CORNEA;
  const leftANTERIOR_CHAMBER = khamMat?.leftJsonValue?.ANTERIOR_CHAMBER;
  const leftPUPIL = khamMat?.leftJsonValue?.PUPIL;

  const leftIRIS = khamMat?.leftJsonValue?.IRIS;
  const leftLENS = khamMat?.leftJsonValue?.LENS;
  const leftEXTRAOCULAR_MOVEMENTS_SQUINT =
    khamMat?.leftJsonValue?.EXTRAOCULAR_MOVEMENTS_SQUINT;
  const leftINTRAOCULAR_PRESSURE = khamMat?.leftJsonValue?.INTRAOCULAR_PRESSURE;

  const leftGONIOSCOPY = khamMat?.rightJsonValue?.GONIOSCOPY;
  const leftFUNDUS = khamMat?.leftJsonValue?.FUNDUS;

  let htmlSideLeft = "";
  if (leftAPPEARANC) {
    const title = `<strong>Hình dạng: </strong>`;
    const data = Object.keys(leftAPPEARANC)
      .filter(key => leftAPPEARANC[key] && key !== "show")
      .map(key => {
        if (key == "Không có nhãn cầu") {
          return `<p>- Không có nhãn cầu</p>`;
        } else {
          return `<p>- ${key}: Có</p>`;
        }
      });
    htmlSideLeft = htmlSideLeft + title + data.join("");
  }
  if (leftINJURY) {
    if (!checkEmptyObj(leftINJURY)) {
      const title = `<strong>Chấn thương: </strong>`;
      const data = Object.keys(leftINJURY)
        .filter(key => leftINJURY[key] && key !== "show")
        .map(key => {
          if (key == "OpenGlobeInjuries") {
            return hanleArray(leftINJURY[key], "Chấn thương nhãn cầu hở");
          }
          if (key == "ClosedGlobeInjuries") {
            return hanleArray(leftINJURY[key], "Chấn thương nhãn cầu kín");
          }
          if (key == "Dị vật nội nhãn") {
            return hanleArray(leftINJURY[key], key);
          } else {
            return handleInforItem(key, leftINJURY[key]);
          }
        });
      htmlSideLeft = htmlSideLeft + title + data.join("");
    }
  }
  if (leftAPPENDAGES) {
    if (!checkEmptyObj(leftAPPENDAGES)) {
      const title = `<div><strong>Phần phụ: </strong><div>`;
      const data = Object.keys(leftAPPENDAGES)
        .filter(key => leftAPPENDAGES[key] && key !== "show" && key != "Option")
        .map(key => {
          if (key == "Ghi chú" || key == "Thăm dò lệ đạo") {
            return handleInforItem(key, leftAPPENDAGES[key]);
          } else {
            return hanleArray(leftAPPENDAGES[key], key);
          }
        });
      htmlSideLeft = htmlSideLeft + title + data.join("");
    }
  }

  if (leftCONJUNCTIVA) {
    if (!checkEmptyObj(leftCONJUNCTIVA)) {
      const title = `<div><strong>Kết mạc: </strong><div>`;
      const data = Object.keys(leftCONJUNCTIVA)
        .filter(
          key =>
            leftCONJUNCTIVA[key] && key !== "show" && key != "Congestion_Option"
        )
        .map(key => {
          if (key == "Ghi chú") {
            return handleInforItem(key, leftCONJUNCTIVA[key]);
          } else {
            return handleInforItem(key, "Có");
          }
        });
      htmlSideLeft = htmlSideLeft + title + data.join("");
    }
  }
  if (leftSCLERA) {
    if (!checkEmptyObj(leftSCLERA)) {
      const title = `<div><strong>Củng mạc: </strong><div>`;
      const data = Object.keys(leftSCLERA)
        .filter(key => leftSCLERA[key] && key !== "show")
        .map(key => {
          return handleInforItem("Ghi chú", leftSCLERA[key]);
        });
      htmlSideLeft = htmlSideLeft + title + data.join("");
    }
  }
  if (leftCORNEA) {
    if (!checkEmptyObj(leftCORNEA)) {
      const title = `<div><strong>Giác mạc: </strong><div>`;
      const data = Object.keys(leftCORNEA)
        .filter(
          key =>
            leftCORNEA[key] &&
            key !== "show" &&
            key != "Option" &&
            key != "Test Schirmer 2Inside" &&
            key != "Test Schirmer 1Inside"
        )
        .map(key => {
          if (key == "Bề mặt") {
            return hanleArray(leftCORNEA[key], key);
          } else if (key == "FormList") {
            return `
              ${leftCORNEA[key].map((e, index) => {
                if (e?.input1) {
                  return `<div>
                      <span> • CCT ${index + 1}</span>:<span>${
                    e?.input1
                  } μm lúc ${e?.input2}</span>
                     
                     
                    </div>`;
                }
              })}
              `;
          } else if (key == "Test Schirmer 1") {
            return `<div>
                    <span>${key}: ${leftCORNEA["Test Schirmer 1Inside"]} trong ${leftCORNEA["Test Schirmer 1Inside"]} phút</span>
                  </div>`;
          } else if (key == "Test Schirmer 2") {
            return `<div>
                    <span>${key}: ${leftCORNEA["Test Schirmer 2Inside"]} trong ${leftCORNEA["Test Schirmer 2Inside"]} phút</span>
                  </div>`;
          } else {
            return handleInforItem(key, leftCORNEA[key]);
          }
        });
      htmlSideLeft = htmlSideLeft + title + data.join("");
    }
  }
  if (leftANTERIOR_CHAMBER) {
    if (!checkEmptyObj(leftANTERIOR_CHAMBER)) {
      const title = `<div><strong>Tiền phòng: </strong><div>`;
      const data = Object.keys(leftANTERIOR_CHAMBER)
        .filter(
          key => leftANTERIOR_CHAMBER[key] && key !== "show" && key != "Option"
        )
        .map(key => {
          if (key == "Ghi chú") {
            return handleInforItem("Ghi chú", leftANTERIOR_CHAMBER[key]);
          } else {
            return handleInforItem(
              key,
              leftANTERIOR_CHAMBER[key] === true
                ? "Có"
                : leftANTERIOR_CHAMBER[key]
            );
          }
        });
      htmlSideLeft = htmlSideLeft + title + data.join("");
    }
  }
  if (leftPUPIL) {
    if (!checkEmptyObj(leftPUPIL)) {
      const title = `<div><strong>Đồng tử: </strong><div>`;
      const data = Object.keys(leftPUPIL)
        .filter(key => leftPUPIL[key] && key !== "show" && key != "Option")
        .map(key => {
          if (key == "Ghi chú" || key == "Kích cỡ đồng tử") {
            return handleInforItem(key, leftPUPIL[key]);
          } else {
            return handleInforItem(
              key,
              leftPUPIL[key] === true ? "Có" : leftPUPIL[key]
            );
          }
        });
      htmlSideLeft = htmlSideLeft + title + data.join("");
    }
  }
  if (leftIRIS) {
    if (!checkEmptyObj(leftIRIS)) {
      const title = `<div><strong>Mống mắt: </strong><div>`;
      const data = Object.keys(leftIRIS)
        .filter(key => leftIRIS[key] && key !== "show" && key != "Option")
        .map(key => {
          if (key == "Ghi chú" || key == "Hình dạng" || key == "Dính mống") {
            return handleInforItem(key, leftIRIS[key]);
          } else {
            return handleInforItem(key, "Có");
          }
        });
      htmlSideLeft = htmlSideLeft + title + data.join("");
    }
  }
  if (leftLENS) {
    if (!checkEmptyObj(leftLENS)) {
      const title = `<div><strong>Thủy tinh thể: </strong><div>`;
      const data = Object.keys(leftLENS)
        .filter(
          key =>
            (leftLENS[key] &&
              key != "show" &&
              key != "Option" &&
              key != "NS" &&
              key != "C" &&
              key != "P") ||
            key == "Phân loại LOCS"
        )
        .map(key => {
          if (key == "Ghi chú") {
            return handleInforItem(key, leftLENS[key]);
          } else if (key == "Phân loại LOCS") {
            const res = `${
              leftLENS["NS"] || leftLENS["C"] || leftLENS["P"]
                ? `<div>
                    • Phân loại LOCS: ${
                      leftLENS["NS"]
                        ? `<span>NS = ${leftLENS["NS"]}</span>`
                        : ""
                    }
                    ${leftLENS["C"] ? `<span>C = ${leftLENS["C"]}</span>` : ""}
                    ${leftLENS["P"] ? `<span>P = ${leftLENS["P"]}</span>` : ""}
                  </div>`
                : ""
            }`;
            return res;
          } else {
            return handleInforItem(
              key,
              leftLENS[key] == true ? "Có" : leftLENS[key]
            );
          }
        });
      htmlSideLeft = htmlSideLeft + title + data.join("");
    }
  }

  if (leftEXTRAOCULAR_MOVEMENTS_SQUINT) {
    if (!checkEmptyObj(leftEXTRAOCULAR_MOVEMENTS_SQUINT)) {
      const title = `<div><strong>Vận nhãn và lác: </strong><div>`;
      const data = Object.keys(leftEXTRAOCULAR_MOVEMENTS_SQUINT)
        .filter(
          key =>
            leftEXTRAOCULAR_MOVEMENTS_SQUINT[key] &&
            key != "show" &&
            key != "Lác hiện" &&
            key != "Chiều ngang" &&
            key != "Lác trong" &&
            key != "Lác liệt" &&
            key != "Lác ẩn"
        )
        .map(key => {
          if (key == "Lác") {
            if (leftEXTRAOCULAR_MOVEMENTS_SQUINT["Lác liệt"]) {
              return hanleArray(
                leftEXTRAOCULAR_MOVEMENTS_SQUINT["Lác liệt"],
                "Lác liệt"
              );
            } else
              return `Lác: ${leftEXTRAOCULAR_MOVEMENTS_SQUINT["Lác"]} ${
                leftEXTRAOCULAR_MOVEMENTS_SQUINT["Lác hiện"] ||
                leftEXTRAOCULAR_MOVEMENTS_SQUINT["Lác ẩn"]
                  ? `- ${
                      leftEXTRAOCULAR_MOVEMENTS_SQUINT["Lác hiện"] ||
                      leftEXTRAOCULAR_MOVEMENTS_SQUINT["Lác ẩn"]
                    }`
                  : ""
              } ${leftEXTRAOCULAR_MOVEMENTS_SQUINT["Lác hiện"] ? " -" : ""} ${
                leftEXTRAOCULAR_MOVEMENTS_SQUINT["Chiều ngang"] ||
                leftEXTRAOCULAR_MOVEMENTS_SQUINT["Chiều dọc"]
              } ${
                leftEXTRAOCULAR_MOVEMENTS_SQUINT["Lác trong"] ||
                leftEXTRAOCULAR_MOVEMENTS_SQUINT["Lác ngoài"]
                  ? `- ${
                      leftEXTRAOCULAR_MOVEMENTS_SQUINT["Lác trong"] ||
                      leftEXTRAOCULAR_MOVEMENTS_SQUINT["Lác ngoài"]
                    }`
                  : ""
              }`;
          } else {
            return handleInforItem(key, leftEXTRAOCULAR_MOVEMENTS_SQUINT[key]);
          }
        });
      htmlSideLeft = htmlSideLeft + title + data.join("");
    }
  }
  if (leftINTRAOCULAR_PRESSURE) {
    if (!checkEmptyObj(leftINTRAOCULAR_PRESSURE)) {
      const title = `<div><strong>Nhãn áp: </strong><div>`;
      const data = Object.keys(leftINTRAOCULAR_PRESSURE)
        .filter(key => leftINTRAOCULAR_PRESSURE[key] && key != "show")
        .map(key => {
          if (key == "formList") {
            return `<div>${leftINTRAOCULAR_PRESSURE[key].map((e, index) => {
              return `${
                (e?.mmHg || e?.mmHG == 0) &&
                `<div><span>Lần đo ${index + 1}: ${e?.mmHg} mmHg ${
                  e?.method ? `- Phương pháp ${e?.method}` : ""
                }</span> </div>`
              } `;
            })}</div>`;
          } else if (key == "Comment") {
            return handleInforItem("Ghi chú", leftINTRAOCULAR_PRESSURE[key]);
          }
        });
      htmlSideLeft = data ? htmlSideLeft + title + data.join("") : "";
    }
  }

  if (leftGONIOSCOPY) {
    if (!checkEmptyObj(leftGONIOSCOPY)) {
      const title = `<div><strong>Soi góc tiền phòng: </strong><div>`;

      const data = Object.keys(leftGONIOSCOPY)
        .filter(
          key =>
            leftGONIOSCOPY[key] &&
            key != "show" &&
            (leftGONIOSCOPY[key]?.select1 ||
              leftGONIOSCOPY[key]?.select2 ||
              leftGONIOSCOPY[key]?.select3)
        )
        .map(key => {
          return `<div><span> • ${key}: </span> ${
            leftGONIOSCOPY[key]?.select1 ?? "--"
          } / ${leftGONIOSCOPY[key]?.select2 ?? "--"} / ${
            leftGONIOSCOPY[key]?.select3 ?? "--"
          }
          </div>`;
        });
      const data2 = leftGONIOSCOPY["Dưới"]?.Comments
        ? handleInforItem("Ghi chú", leftGONIOSCOPY["Dưới"]?.Comments)
        : "";
      htmlSideLeft = htmlSideLeft + title + data.join("") + data2;
    }
  }
  if (leftFUNDUS) {
    if (!checkEmptyObj(leftFUNDUS)) {
      const title = `<div><strong>Đáy mắt: </strong><div>`;
      const data = Object.keys(leftFUNDUS)
        .filter(key => leftFUNDUS[key] && key != "show" && key != "Option")
        .map(key => {
          if (
            key == "Bong võng mạc" ||
            key == "Dịch kính" ||
            key == "Mạch máu" ||
            key == "Quan sát" ||
            key == "Tổn thương đáy mắt" ||
            key == "Tỷ lệ C/D"
          ) {
            if (!checkEmptyObj(leftFUNDUS[key])) {
              const res = `<div>
              ${key}: ${leftFUNDUS[key]?.text1} ${
                leftFUNDUS[key]?.text1 && leftFUNDUS[key]?.text2 ? "-" : ""
              } ${leftFUNDUS[key]?.text2 ?? ""}
          </div>`;
              return res;
            } else return "";
          } else if (key == "Hoàng điểm") {
            return hanleArray(leftFUNDUS[key], key);
          } else {
            return handleInforItem(key, leftFUNDUS[key]);
          }
        });
      htmlSideLeft = htmlSideLeft + title + data.join("");
    }
  }
  setDataEditorLeft(htmlSideLeft);

  // Phải
  //
  //
  const rightINJURY = khamMat?.rightJsonValue?.INJURY;
  const rightLENS = khamMat?.rightJsonValue?.LENS;

  const rightFUNDUS = khamMat?.rightJsonValue?.FUNDUS;
  const rightAPPEARANC = khamMat?.rightJsonValue?.APPEARANCE;
  const rightAPPENDAGES = khamMat?.rightJsonValue?.APPENDAGES;
  const rightCONJUNCTIVA = khamMat?.rightJsonValue?.CONJUNCTIVA;
  const rightSCLERA = khamMat?.rightJsonValue?.SCLERA;
  const rightANTERIOR_CHAMBER = khamMat?.rightJsonValue?.ANTERIOR_CHAMBER;
  const rightPUPIL = khamMat?.rightJsonValue?.PUPIL;
  const rightIRIS = khamMat?.rightJsonValue?.IRIS;
  const rightEXTRAOCULAR_MOVEMENTS_SQUINT =
    khamMat?.rightJsonValue?.EXTRAOCULAR_MOVEMENTS_SQUINT;
  const rightINTRAOCULAR_PRESSURE =
    khamMat?.rightJsonValue?.INTRAOCULAR_PRESSURE;

  const rightCORNEA = khamMat?.rightJsonValue?.CORNEA;
  const rightGONIOSCOPY = khamMat?.rightJsonValue?.GONIOSCOPY;

  let htmlSideRight = "";
  if (rightAPPEARANC) {
    const title = `<strong>Hình dạng: </strong>`;
    const data = Object.keys(rightAPPEARANC)
      .filter(key => rightAPPEARANC[key] && key !== "show")
      .map(key => {
        if (key == "Không có nhãn cầu") {
          return `<p>- Không có nhãn cầu</p>`;
        } else {
          return `<p>- ${key}: Có</p>`;
        }
      });
    htmlSideRight = htmlSideRight + title + data.join("");
  }
  if (rightINJURY) {
    if (!checkEmptyObj(rightINJURY)) {
      const title = `<strong>Chấn thương: </strong>`;
      const data = Object.keys(rightINJURY)
        .filter(key => rightINJURY[key] && key !== "show")
        .map(key => {
          if (key == "OpenGlobeInjuries") {
            return hanleArray(rightINJURY[key], "Chấn thương nhãn cầu hở");
          }
          if (key == "ClosedGlobeInjuries") {
            return hanleArray(rightINJURY[key], "Chấn thương nhãn cầu kín");
          }
          if (key == "Dị vật nội nhãn") {
            return hanleArray(rightINJURY[key], key);
          } else {
            return handleInforItem(key, rightINJURY[key]);
          }
        });
      htmlSideRight = htmlSideRight + title + data.join("");
    }
  }
  if (rightAPPENDAGES) {
    if (!checkEmptyObj(rightAPPENDAGES)) {
      const title = `<div><strong>Phần phụ: </strong><div>`;
      const data = Object.keys(rightAPPENDAGES)
        .filter(
          key => rightAPPENDAGES[key] && key !== "show" && key != "Option"
        )
        .map(key => {
          if (key == "Ghi chú" || key == "Thăm dò lệ đạo") {
            return handleInforItem(key, rightAPPENDAGES[key]);
          } else {
            return hanleArray(rightAPPENDAGES[key], key);
          }
        });
      htmlSideRight = htmlSideRight + title + data.join("");
    }
  }

  if (rightCONJUNCTIVA) {
    if (!checkEmptyObj(rightCONJUNCTIVA)) {
      const title = `<div><strong>Kết mạc: </strong><div>`;
      const data = Object.keys(rightCONJUNCTIVA)
        .filter(
          key =>
            rightCONJUNCTIVA[key] &&
            key !== "show" &&
            key != "Congestion_Option"
        )
        .map(key => {
          if (key == "Ghi chú") {
            return handleInforItem(key, rightCONJUNCTIVA[key]);
          } else {
            return handleInforItem(key, "Có");
          }
        });
      htmlSideRight = htmlSideRight + title + data.join("");
    }
  }
  if (rightSCLERA) {
    if (!checkEmptyObj(rightSCLERA)) {
      const title = `<div><strong>Củng mạc: </strong><div>`;
      const data = Object.keys(rightSCLERA)
        .filter(key => rightSCLERA[key] && key !== "show")
        .map(key => {
          return handleInforItem("Ghi chú", rightSCLERA[key]);
        });
      htmlSideRight = htmlSideRight + title + data.join("");
    }
  }
  if (rightCORNEA) {
    if (!checkEmptyObj(rightCORNEA)) {
      const title = `<div><strong>Giác mạc: </strong><div>`;
      const data = Object.keys(rightCORNEA)
        .filter(
          key =>
            rightCORNEA[key] &&
            key !== "show" &&
            key != "Option" &&
            key != "Test Schirmer 2Inside" &&
            key != "Test Schirmer 1Inside"
        )
        .map(key => {
          if (key == "Bề mặt") {
            return hanleArray(rightCORNEA[key], key);
          } else if (key == "FormList") {
            return `
              ${rightCORNEA[key].map((e, index) => {
                if (e?.input1) {
                  return `<div>
                      <span> • CCT ${index + 1}</span>:<span>${
                    e?.input1
                  } μm lúc ${e?.input2}</span>
                     
                     
                    </div>`;
                }
              })}
              `;
          } else if (key == "Test Schirmer 1") {
            return `<div>
                    <span>${key}: ${rightCORNEA["Test Schirmer 1Inside"]} trong ${rightCORNEA["Test Schirmer 1Inside"]} phút</span>
                  </div>`;
          } else if (key == "Test Schirmer 2") {
            return `<div>
                    <span>${key}: ${rightCORNEA["Test Schirmer 2Inside"]} trong ${rightCORNEA["Test Schirmer 2Inside"]} phút</span>
                  </div>`;
          } else {
            return handleInforItem(key, rightCORNEA[key]);
          }
        });
      htmlSideRight = htmlSideRight + title + data.join("");
    }
  }
  if (rightANTERIOR_CHAMBER) {
    if (!checkEmptyObj(rightANTERIOR_CHAMBER)) {
      const title = `<div><strong>Tiền phòng: </strong><div>`;
      const data = Object.keys(rightANTERIOR_CHAMBER)
        .filter(
          key => rightANTERIOR_CHAMBER[key] && key !== "show" && key != "Option"
        )
        .map(key => {
          if (key == "Ghi chú") {
            return handleInforItem("Ghi chú", rightANTERIOR_CHAMBER[key]);
          } else {
            return handleInforItem(
              key,
              rightANTERIOR_CHAMBER[key] === true
                ? "Có"
                : rightANTERIOR_CHAMBER[key]
            );
          }
        });
      htmlSideRight = htmlSideRight + title + data.join("");
    }
  }
  if (rightPUPIL) {
    if (!checkEmptyObj(rightPUPIL)) {
      const title = `<div><strong>Đồng tử: </strong><div>`;
      const data = Object.keys(rightPUPIL)
        .filter(key => rightPUPIL[key] && key !== "show" && key != "Option")
        .map(key => {
          if (key == "Ghi chú" || key == "Kích cỡ đồng tử") {
            return handleInforItem(key, rightPUPIL[key]);
          } else {
            return handleInforItem(
              key,
              rightPUPIL[key] === true ? "Có" : rightPUPIL[key]
            );
          }
        });
      htmlSideRight = htmlSideRight + title + data.join("");
    }
  }
  if (rightIRIS) {
    if (!checkEmptyObj(rightIRIS)) {
      const title = `<div><strong>Mống mắt: </strong><div>`;
      const data = Object.keys(rightIRIS)
        .filter(key => rightIRIS[key] && key !== "show" && key != "Option")
        .map(key => {
          if (key == "Ghi chú" || key == "Hình dạng" || key == "Dính mống") {
            return handleInforItem(key, rightIRIS[key]);
          } else {
            return handleInforItem(key, "Có");
          }
        });
      htmlSideRight = htmlSideRight + title + data.join("");
    }
  }
  if (rightLENS) {
    if (!checkEmptyObj(rightLENS)) {
      const title = `<div><strong>Thủy tinh thể: </strong><div>`;
      const data = Object.keys(rightLENS)
        .filter(
          key =>
            (rightLENS[key] &&
              key != "show" &&
              key != "Option" &&
              key != "NS" &&
              key != "C" &&
              key != "P") ||
            key == "Phân loại LOCS"
        )
        .map(key => {
          if (key == "Ghi chú") {
            return handleInforItem(key, rightLENS[key]);
          } else if (key == "Phân loại LOCS") {
            const res = `${
              rightLENS["NS"] || rightLENS["C"] || rightLENS["P"]
                ? `<div>
                    • Phân loại LOCS: ${
                      rightLENS["NS"]
                        ? `<span>NS = ${rightLENS["NS"]}</span>`
                        : ""
                    }
                    ${
                      rightLENS["C"] ? `<span>C = ${rightLENS["C"]}</span>` : ""
                    }
                    ${
                      rightLENS["P"] ? `<span>P = ${rightLENS["P"]}</span>` : ""
                    }
                  </div>`
                : ""
            }`;
            return res;
          } else {
            return handleInforItem(
              key,
              rightLENS[key] == true ? "Có" : rightLENS[key]
            );
          }
        });
      htmlSideRight = htmlSideRight + title + data.join("");
    }
  }

  if (rightEXTRAOCULAR_MOVEMENTS_SQUINT) {
    if (!checkEmptyObj(rightEXTRAOCULAR_MOVEMENTS_SQUINT)) {
      const title = `<div><strong>Vận nhãn và lác: </strong><div>`;
      const data = Object.keys(rightEXTRAOCULAR_MOVEMENTS_SQUINT)
        .filter(
          key =>
            rightEXTRAOCULAR_MOVEMENTS_SQUINT[key] &&
            key != "show" &&
            key != "Lác hiện" &&
            key != "Chiều ngang" &&
            key != "Lác trong" &&
            key != "Lác liệt" &&
            key != "Lác ẩn"
        )
        .map(key => {
          if (key == "Lác") {
            if (rightEXTRAOCULAR_MOVEMENTS_SQUINT["Lác liệt"]) {
              return hanleArray(
                rightEXTRAOCULAR_MOVEMENTS_SQUINT["Lác liệt"],
                "Lác liệt"
              );
            } else
              return `Lác: ${rightEXTRAOCULAR_MOVEMENTS_SQUINT["Lác"]} ${
                rightEXTRAOCULAR_MOVEMENTS_SQUINT["Lác hiện"] ||
                rightEXTRAOCULAR_MOVEMENTS_SQUINT["Lác ẩn"]
                  ? `- ${
                      rightEXTRAOCULAR_MOVEMENTS_SQUINT["Lác hiện"] ||
                      rightEXTRAOCULAR_MOVEMENTS_SQUINT["Lác ẩn"]
                    }`
                  : ""
              } ${rightEXTRAOCULAR_MOVEMENTS_SQUINT["Lác hiện"] ? " -" : ""} ${
                rightEXTRAOCULAR_MOVEMENTS_SQUINT["Chiều ngang"] ||
                rightEXTRAOCULAR_MOVEMENTS_SQUINT["Chiều dọc"]
              } ${
                rightEXTRAOCULAR_MOVEMENTS_SQUINT["Lác trong"] ||
                rightEXTRAOCULAR_MOVEMENTS_SQUINT["Lác ngoài"]
                  ? `- ${
                      rightEXTRAOCULAR_MOVEMENTS_SQUINT["Lác trong"] ||
                      rightEXTRAOCULAR_MOVEMENTS_SQUINT["Lác ngoài"]
                    }`
                  : ""
              }`;
          } else {
            return handleInforItem(key, rightEXTRAOCULAR_MOVEMENTS_SQUINT[key]);
          }
        });
      htmlSideRight = htmlSideRight + title + data.join("");
    }
  }
  if (rightINTRAOCULAR_PRESSURE) {
    if (!checkEmptyObj(rightINTRAOCULAR_PRESSURE)) {
      const title = `<div><strong>Nhãn áp: </strong><div>`;
      const data = Object.keys(rightINTRAOCULAR_PRESSURE)
        .filter(key => rightINTRAOCULAR_PRESSURE[key] && key != "show")
        .map(key => {
          if (key == "formList") {
            return `<div>${rightINTRAOCULAR_PRESSURE[key].map((e, index) => {
              return `${
                (e?.mmHg || e?.mmHG == 0) &&
                `<div><span>Lần đo ${index + 1}: ${e?.mmHg} mmHg ${
                  e?.method ? `- Phương pháp ${e?.method}` : ""
                }</span> </div>`
              } `;
            })}</div>`;
          } else if (key == "Comment") {
            return handleInforItem("Ghi chú", rightINTRAOCULAR_PRESSURE[key]);
          }
        });
      htmlSideRight = data ? htmlSideRight + title + data.join("") : "";
    }
  }

  if (rightGONIOSCOPY) {
    if (!checkEmptyObj(rightGONIOSCOPY)) {
      const title = `<div><strong>Soi góc tiền phòng: </strong><div>`;

      const data = Object.keys(rightGONIOSCOPY)
        .filter(
          key =>
            rightGONIOSCOPY[key] &&
            key != "show" &&
            (rightGONIOSCOPY[key]?.select1 ||
              rightGONIOSCOPY[key]?.select2 ||
              rightGONIOSCOPY[key]?.select3)
        )
        .map(key => {
          return `<div><span> • ${key}: </span> ${
            rightGONIOSCOPY[key]?.select1 ?? "--"
          } / ${rightGONIOSCOPY[key]?.select2 ?? "--"} / ${
            rightGONIOSCOPY[key]?.select3 ?? "--"
          }
          </div>`;
        });
      const data2 = rightGONIOSCOPY["Dưới"]?.Comments
        ? handleInforItem("Ghi chú", rightGONIOSCOPY["Dưới"]?.Comments)
        : "";
      htmlSideRight = htmlSideRight + title + data.join("") + data2;
    }
  }
  if (rightFUNDUS) {
    if (!checkEmptyObj(rightFUNDUS)) {
      const title = `<div><strong>Đáy mắt: </strong><div>`;
      const data = Object.keys(rightFUNDUS)
        .filter(key => rightFUNDUS[key] && key != "show" && key != "Option")
        .map(key => {
          if (
            key == "Bong võng mạc" ||
            key == "Dịch kính" ||
            key == "Mạch máu" ||
            key == "Quan sát" ||
            key == "Tổn thương đáy mắt" ||
            key == "Tỷ lệ C/D"
          ) {
            if (!checkEmptyObj(rightFUNDUS[key])) {
              return `<div>
                  ${key}: ${rightFUNDUS[key]?.text1} ${
                rightFUNDUS[key]?.text1 && rightFUNDUS[key]?.text2 ? "-" : ""
              } ${rightFUNDUS[key]?.text2 ?? ""}
              </div>`;
            }
          } else if (key == "Hoàng điểm") {
            return hanleArray(rightFUNDUS[key], key);
          } else {
            return handleInforItem(key, rightFUNDUS[key]);
          }
        });
      htmlSideRight = htmlSideRight + title + data.join("");
    }
  }

  setDataEditorRight(htmlSideRight);
};

export default CheckDataKhamMat;
